import React from 'react'
import { Redirect, useParams } from 'react-router-dom'
import { t } from 'i18next'
import Navigation from 'Components/Navigation'
import useValidatePermission from 'Hooks/useValidatePermission'
import { VAPermissions, ROUTES } from 'Utils/constants'
import './QuickListInformation.css'
import QuickListInformation from './QuickListInformation'

export default function QuickListInformationPage() {
  const hasQuickListSettingsPermission = useValidatePermission(
    VAPermissions.settingsQuickList
  )
  const { id } = useParams()

  if (!hasQuickListSettingsPermission) {
    return <Redirect to={ROUTES.home} />
  }

  const editMode = Boolean(id)

  return (
    <>
      <Navigation />
      <div className="quick-list-information-container">
        <h1>
          {editMode
            ? t('QUICK_LIST_SETTINGS.FORM.TITLE_EDIT')
            : t('QUICK_LIST_SETTINGS.FORM.TITLE_NEW')}
        </h1>
        <QuickListInformation id={id} editMode={editMode} />
      </div>
    </>
  )
}
